import PropTypes from "prop-types";
import { isFunction } from "lodash";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { useSortableBookmarkContext } from "../context/SortableBookmark";

export const ManageBookmarkActions = ({
  bookmark,
  onEditClick,
  onDeleteClick,
}) => {
  const { setIsFolderDropdownOpen } = useSortableBookmarkContext();

  return (
    <Dropdown
      direction="bottom-start"
      buttonClassName="flex w-5 h-5 hover:bg-black/10 rounded"
      transitionWrapperClassName="pt-2.5"
      button={<Icon type="menu-dots-v2" className="text-dark" size={16} />}
      onToggle={isOpen => setIsFolderDropdownOpen(isOpen)}
    >
      <Dropdown.ItemWithLink
        onClick={event => {
          event.preventDefault();
          isFunction(onEditClick) && onEditClick(bookmark);
        }}
      >
        {t("edit")}
      </Dropdown.ItemWithLink>
      <Dropdown.ItemWithLink
        onClick={event => {
          event.preventDefault();
          isFunction(onDeleteClick) && onDeleteClick(bookmark);
        }}
      >
        {t("delete")}
      </Dropdown.ItemWithLink>
    </Dropdown>
  );
};

ManageBookmarkActions.propTypes = {
  bookmark: PropTypes.object,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};
